module.exports = __webpack_public_path__ + "img/argument-1.9e51b736.svg";